import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import CONSTANTS from '../../_constants/constants';

import { SharedModule } from '../../_shared/shared.module';
import { AbilityService } from '../../_shared/services/ability.service';
import { DataService } from '../../_shared/services/data.service';
import { SessionService } from '../../_shared/services/session.service';
import { UtilService } from '../../_shared/services/util.service';

import { Category } from '../shared/category.model';
import { CategoryService } from '../shared/category.service';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class CategoryListComponent implements OnInit, OnDestroy {
  @Input() categories: Category[];
  @Input() meta; // : []
  @Input() loadingCategories: boolean;
  @Input() defaultLanguage;

  @Output() private selectedCategory = new EventEmitter<{ category: Category; mode: string }>();
  // @Output() private selectedCategory = new EventEmitter<any>();

  permissions = {
    canShow: this.abilityService.can('show_category_accountadmin'),
    canUpdate: this.abilityService.can('update_category_accountadmin'),
    canDestroy: this.abilityService.can('destroy_category_accountadmin'),
  };

  productTypes = CONSTANTS.ALL_PRODUCT_TYPES;

  filterCriteria = this.categoryService.getFilterCriteria();

  masterCheckboxSelected = false;
  showListActions = false;
  totalItemsSelected = 0;

  private $subs: Subscription;

  constructor(
    private categoryService: CategoryService,
    private abilityService: AbilityService,
    private dataService: DataService,
    private sessionService: SessionService,
    public utilService: UtilService
  ) {}

  ngOnInit() {
    this.$subs = this.utilService.getCheckboxsSubjectValue().subscribe((data) => {
      this.showListActions = data.showListActions;
      this.totalItemsSelected = data.totalItemsSelected;
      this.masterCheckboxSelected = data.masterCheckboxSelected;
    });
  }

  ngOnDestroy() {
    if (this.$subs) {
      this.$subs.unsubscribe();
    }
  }

  reloadCategories() {
    this.filterCriteria = this.categoryService.getFilterCriteria();

    this.getCategories();
  }

  // Referenced from app-search-text-input
  onSearched({ field, value }) {
    this.filterCategories(field, value);
  }

  filterCategories(field, value) {
    this.filterCriteria = this.utilService.setFilterCriteria(this.filterCriteria, field, value);

    this.getCategories();
  }

  // Referenced from app-sort-by
  onSorted({ sortBy, sortDir }) {
    this.filterCriteria.page = 1;
    this.filterCriteria.sortDir = sortDir;
    this.filterCriteria.sortedBy = sortBy;

    this.getCategories();
  }

  // Referenced from app-table-footer
  onSelectedPage({ page, offset }) {
    this.filterCriteria.page = page;
    this.filterCriteria.offset = offset;

    this.getCategories();
  }

  selectCategory(category: Category, mode = '') {
    if (!this.permissions.canShow) return;

    this.selectedCategory.emit({ category, mode });
  }

  // Referenced from app-list-actions
  onUpdatedItems(option) {
    let successCallback = () => {
      this.getCategories();
    };

    this.dataService.changeItemsStatus('categories', this.categories, option, successCallback);
  }

  // Referenced from app-list-actions
  onDeletedItems() {
    let successCallback = () => {
      this.getCategories();
    };

    this.dataService.deleteItems('categories', this.categories, successCallback);
  }

  changeCategoryStatus(category: Category) {
    let successCallback = () => {
      this.utilService.changeItemRowStyle(category.id);
    };

    this.dataService.changeItemStatus('categories', category, successCallback, {});
  }

  deleteCategory(category: Category) {
    let successCallback = () => {
      this.getCategories();
    };

    const params = {
      title: 'DELETE_FACILITY',
      message: 'SURE_TO_DELETE_FACILITY',
      reason: 'DELETE_ITEM_REASON',
      requireConfirmation: true,
      successMsg: 'DELETED_FACILITY',
    };

    this.dataService.deleteItem('categories', category, successCallback, params);
  }

  private getCategories() {
    this.filterCriteria.lang = this.sessionService.getUserLanguage().code;

    this.loadingCategories = true;
    this.categoryService.getCategories(this.filterCriteria).subscribe((response) => {
      this.categories = response.data;
      this.meta = response.meta;

      this.loadingCategories = false;
    });
  }
}
